import { render } from "./OurNetwork.vue?vue&type=template&id=5c97dde6"
import script from "./OurNetwork.vue?vue&type=script&lang=js"
export * from "./OurNetwork.vue?vue&type=script&lang=js"

import "./OurNetwork.vue?vue&type=style&index=0&id=5c97dde6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__